import {ChangeDetectorRef, Component, Input, ViewEncapsulation} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {EventActivity, EventLogActivity} from '../../../../projects/api/src/event-log/event-log.model';
import {EventLogApiService} from '../../../../projects/api/src/event-log/event-log-api.service';
import {DialogService} from 'primeng/dynamicdialog';
import {CommonModule} from '@angular/common';
import {InsparkComponentsModule} from '@inspark/inspark-components';

export enum SORT {
  new,
  critical
}

@Component({
    selector: 'app-events-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [DialogService, MessageService],
    imports: [CommonModule, InsparkComponentsModule, TranslateModule]
})
export class EventsInfoComponent  {


  @Input() item: EventLogActivity;

  activities: { [k: string]: { loading: boolean; data: EventActivity[] } } = {};


  constructor(private ngxTranslateService: TranslateService,
              private deviceService: DeviceDetectorService,
              private eventLogApiService: EventLogApiService,
              private cdRef: ChangeDetectorRef) {
  }


  onShowChat(item: EventLogActivity) {
    this.activities[item.id] = {loading: true, data: []};
    this.eventLogApiService.getMessages(item.id).subscribe(items => {
      this.activities[item.id] = {loading: false, data: items};
    });
  }


}





